export default __webpack_public_path__ + "static/media/Kvalitet 3.e04aaf51.jpg";